<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">物料编号</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.pd_prodcode }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">序号</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.pd_detno }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">物料名称</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.productDTO.pr_detail }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">型号</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.productDTO.pr_orispeccode }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">厂家/品牌</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.productDTO.pr_brand }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">物料规格</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.productDTO.pr_spec }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">单位</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.productDTO.pr_unit }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">数量</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.pd_qty }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">变更原因</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.pd_remark"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">需供应商确认</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.pc_confirm"
              placeholder="请选择"
            >
              <option>是</option>
              <option>否</option>
            </select>
          </div>
        </div>
      </div>

      <div class="weui-cells__group">
        <div class="weui-cells__title">
          <span>分拆{{ 1 }}</span>
        </div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">数量</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.pd_qty"
                placeholder="请填写"
              />
            </div>
          </div>
          <!-- <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">已转数</label>
            </div>
            <div class="weui-cell__bd">{{  }}</div>
          </div> -->
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">含税单价</label>
            </div>
            <div class="weui-cell__bd">{{ form.pd_price }}</div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">税率</label>
            </div>
            <div class="weui-cell__bd">{{ form.pd_taxrate }}</div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">需求日期</label>
            </div>
            <div class="weui-cell__bd">{{ form.pd_delivery }}</div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">返利率</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.pd_rebaterate"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">抵扣金额</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.pd_deductionamount"
                placeholder="请填写"
              />
            </div>
          </div>
          <a
            href="javascript:"
            v-if="form.splitList.length == 0"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.splitList"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>分拆{{ xindex + 2 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">数量</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.ps_qty"
                placeholder="请填写"
              />
            </div>
          </div>
          <!-- <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">已转数</label>
            </div>
            <div class="weui-cell__bd">{{  }}</div>
          </div> -->
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">含税单价</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.ps_price"
                @change="calcItem"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">税率</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.ps_taxrate"
                @change="calcItem"
                placeholder="请填写"
              />
            </div>
          </div>
          <date-field :label="'需求日期'" v-model="item.ps_delivery"/>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">返利率</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.ps_rebaterate"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">抵扣金额</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.ps_deduction"
                placeholder="请填写"
              />
            </div>
          </div>
          <a
            href="javascript:"
            v-if="xindex == form.splitList.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="onsave"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import DateField from "@/components/field/DateField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    DateField
  },
  mixins: [process],
  props: {
    itemData: Object,
  },
  data() {
    return {
      baseUrl: "/api/purchase/purchase/modifyDetail",
      codeField: "pc_code",
      statusField: "pc_statuscode",
      caller: "PurchaseChange",
      xtype: "purchase-change-formpanel",
      form: {
        id: null,
        ipdprice: 0,
        pc_confirm: 0,
        pd_deductionamount: 0,
        pd_delivery: "",
        pd_price: 0,
        pd_qty: 0,
        pd_rebaterate: 0,
        pd_remark: "",
        pd_taxrate: 13,
        pd_taxprice: 0,
        splitList: [
          // {
          //   ipdprice: 0,
          //   ps_deduction: 0,
          //   ps_delivery: '',
          //   ps_netprice: 0,
          //   ps_price: 0,
          //   ps_qty: 0,
          //   ps_rebaterate: 0,
          //   ps_taxrate: 0
          // }
        ]
      }
    };
  },
  mounted() {
    if (this.itemData) {
      let { form, itemData } = this
      form.id = itemData.id
      form.pd_qty = itemData.pd_qty
      form.pd_delivery = itemData.pd_delivery
      form.pd_price = itemData.pd_price
      form.pd_taxrate= itemData.pd_taxrate
    }
  },
  methods: {
    calcItem() {
      var me = this,
        form = me.form,
        splitList = form.splitList;

      form.pd_taxprice = me.$number.round(form.pd_price / (1 + form.pd_taxrate / 100), 6);

      splitList.forEach((item) => {
        item.ps_netprice = me.$number.round(item.ps_price / (1 + item.ps_taxrate / 100), 6);
      });
    },
    onsave() {
      var me = this,
        form = me.form,
        splitList = form.splitList,
        checked;
      if (!form.pd_remark) {
        me.$weui.topTips("请填写变更原因", 2000);
        return
      } else if (form.pd_qty < me.itemData.pd_qty) {
        me.$weui.topTips("分拆1的数量不能小于" + me.itemData.pd_qty, 2000);
        return
      } else {
        var count = 0
        splitList.forEach(function (item) {
          if (!item.ps_qty) {
            me.$weui.topTips(`分拆${count + 2}的数量未填写`, 2000);
            return false;
          } else if (!item.ps_delivery) {
            me.$weui.topTips(`分拆${count + 2}的日期未填写`, 2000);
            return false;
          } else {
            count++
          }
        });
        
        checked = count == splitList.length

        if (checked) {
          me.doModify();
        }

      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      this.form.splitList.splice(index, 1);
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        splitList = me.form.splitList;
      splitList.push({
        ipdprice: 0,
        ps_deduction: 0,
        ps_delivery: '',
        ps_netprice: 0,
        ps_price: 0,
        ps_qty: 0,
        ps_rebaterate: 0,
        ps_taxrate: 0
      });
    },
    doModify() {
      var me = this;
      me.$loading({
        url: '/api/purchase/purchase/modifyDetail',
        method: 'POST',
        jsonData: me.form
      }).then(function (res) {
        if(res.success) {
          me.preLaunchProcess(
            me.caller,
            res.data.change,
            me.xtype,
            function () {
              me.$router.back();
            }
          )
        } else {
          me.$weui.topTips(res.message || '变更失败', 2000);
        }
      }).catch(function () {
        me.$weui.topTips('变更失败', 2000);
      });
    }
  },
};
</script>